import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { BookOpen, Map, MessageCircle, Clock, Lightbulb, BarChart, ArrowRight } from 'lucide-react';
import { Button } from './ui/Button';
export function WhatsInside() {
  const features = [{
    icon: Map,
    title: 'El mapa de monetización',
    desc: 'Afiliados, UGC, activo propio simple. Elige 1 sin confundirte.'
  }, {
    icon: BookOpen,
    title: 'El Motor 3-Loop explicado',
    desc: 'Con ejemplos reales para que lo apliques ese mismo día.'
  }, {
    icon: MessageCircle,
    title: 'Prompts atómicos',
    desc: 'Para hooks, guiones, carruseles, comentarios fijados y respuestas por DM.'
  }, {
    icon: Clock,
    title: 'Plan operativo de 30 días',
    desc: 'Horarios, frecuencia y cadencia con un plan mínimo viable.'
  }, {
    icon: Lightbulb,
    title: 'Biblioteca de ideas',
    desc: 'Tipos de contenido prueba y puentes a oferta que no suenan desesperados.'
  }, {
    icon: BarChart,
    title: 'Diagnóstico y optimización',
    desc: 'Qué arreglar cuando hay views pero no ventas (o al revés).'
  }];
  return <Section className="bg-[#0a0a0a]" data-id="element-374">
      <div className="text-center mb-14" data-id="element-375">
        <h2 className="text-3xl md:text-4xl font-black mb-4 text-white" data-id="element-376">
          Qué incluye{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#14b8a6] to-[#2dd4bf]" data-id="element-377">
            INGRESOS DIGITALES ATÓMICOS
          </span>
        </h2>
        <p className="text-gray-400" data-id="element-378">
          Un método práctico para principiantes que quieren monetizar sin ser
          influencer.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-4" data-id="element-379">
        {features.map((feature, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        delay: idx * 0.08,
        duration: 0.4
      }} className="glass-card flex gap-4 p-6 group hover:border-white/10 transition-all duration-300" data-id="element-380">
            <div className="w-10 h-10 rounded-xl bg-[#14b8a6]/10 border border-[#14b8a6]/15 flex items-center justify-center shrink-0 group-hover:bg-[#14b8a6]/20 transition-colors" data-id="element-381">
              <feature.icon className="text-[#14b8a6]" size={20} data-id="element-382" />
            </div>
            <div data-id="element-383">
              <h3 className="font-bold text-white text-lg mb-1.5" data-id="element-384">
                {feature.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-385">
                {feature.desc}
              </p>
            </div>
          </motion.div>)}
      </div>

      <div className="mt-16 text-center" data-id="element-386">
        <p className="text-2xl font-bold text-white mb-6" data-id="element-387">
          ¿Listo para dejar de improvisar?
        </p>
        <Button size="lg" className="text-lg px-10" data-id="element-388">
          QUIERO EL MÉTODO <ArrowRight className="ml-2" size={20} data-id="element-389" />
        </Button>
        <p className="mt-4 text-sm text-gray-500" data-id="element-390">
          Solo $6.39 USD · Descarga inmediata
        </p>
      </div>
    </Section>;
}